// material
import { createStyles } from "@material-ui/core";
export const styles = () =>
  createStyles({
    maintenance: {
      width: "700px",
      margin: "0 auto",
      marginTop: 20,
      border: "2px solid #666",
      padding: "64px 32px",
      boxSizing: 'border-box',
      background: '#fff',
      textAlign: "center",
    },
    maintenanceMessage : {
      fontSize: '34px',
      marginBottom: '24px',
      fontWeight: 'bold',
    },
    maintenanceDate : {
      color: '#fff',
      padding: '8px',
      background: '#cc0000',
      width: '90%',
      margin: '0 auto 16px',
    }
});
